import { createAction, props } from "@ngrx/store";

const prefix = "[View Profile Page]";

export const loadPage = createAction(
  `${prefix} Load Page`,
  props<{ azureId: string; includeHidden?: boolean }>(),
);

export const loadClientPage = createAction(
  `${prefix} Load Client Page`,
  props<{ secret: string }>(),
);

export const unloadPage = createAction(`${prefix} Unload Page`);

/** Clears loading state when profile load fails (401/404/etc). */
export const loadPageError = createAction(`${prefix} Load Page Error`);

export const selectAddSkillUser = createAction(
  `${prefix} Selected User For Adding A User Skill`,
  props<{ azureId: string }>(),
);
